/**
 * Flattens dashboard nav config into searchable command entries.
 */
export function flattenNavToCommands(navData) {
  const commands = [];

  for (const section of navData) {
    const sub = section.subheader || '';

    for (const item of section.items || []) {
      const parentRoles = item.roles;
      // A child is hidden by its own feature flag and by its parent's
      const parentFeatures = item.feature ? [item.feature] : [];

      if (item.children?.length) {
        if (item.path && item.path !== '#') {
          commands.push({
            title: item.title,
            path: item.path,
            sub,
            roles: parentRoles,
            features: parentFeatures,
          });
        }
        for (const child of item.children) {
          if (!child.path || child.path === '#') continue;
          commands.push({
            title: `${item.title} — ${child.title}`,
            path: child.path,
            sub,
            roles: child.roles ?? parentRoles,
            features: child.feature ? [...parentFeatures, child.feature] : parentFeatures,
          });
        }
      } else if (item.path && item.path !== '#') {
        commands.push({
          title: item.title,
          path: item.path,
          sub,
          roles: parentRoles,
          features: parentFeatures,
        });
      }
    }
  }

  return commands;
}
